var Vendd = (function (Vendd) {
    'use strict';

    Vendd.OfflineOrdersHistory = (function (OfflineOrdersHistory) {

        OfflineOrdersHistory.Messages = (function (Messages) {

            Messages.GetOrderItems = function (orderId) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OfflineOrdersHistory.Messages.GetOrderItems', orderId);
            };
            Messages.GetOrderItems.className = 'Vendd.OfflineOrdersHistory.Messages.GetOrderItems';

            Messages.GetOrderItemsSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OfflineOrdersHistory.Messages.GetOrderItemsSuccess', response);
            };
            Messages.GetOrderItemsSuccess.className = 'Vendd.OfflineOrdersHistory.Messages.GetOrderItemsSuccess';

            Messages.GetOrderItemsFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OfflineOrdersHistory.Messages.GetOrderItemsFailure', response);
            };
            Messages.GetOrderItemsFailure.className = 'Vendd.OfflineOrdersHistory.Messages.GetOrderItemsFailure';

            Messages.OrderItemsRendered = function (itemsCount) {
                Vendd.MessageBus.VenddMessage.call(
                    this,
                    'Vendd.OfflineOrdersHistory.Messages.OrderItemsRendered',
                    { itemsCount: itemsCount }
                );
            };
            Messages.OrderItemsRendered.className = 'Vendd.OfflineOrdersHistory.Messages.OrderItemsRendered';

            return Messages;

        })(OfflineOrdersHistory.Messages || {});

        return OfflineOrdersHistory;

    })(Vendd.OfflineOrdersHistory || {})

    return Vendd;

})(Vendd || {});
